import * as React from 'react';
import { AdminEmail } from 'src/sections';

export function AccountLocked(): JSX.Element {
    return (
        <div className="flex-vertical text-align-center ma-2 gap-2">
            <h2 className="white-text">Account Locked</h2>

            <div className="basic-box">
                <p className="white-text">Your account has been disabled.</p> 
                <p className="white-text">
                    If this is unexpected you can email the web admin:
                </p>
                <p>
                    <AdminEmail />
                </p>
            </div>
        </div>
    );
}
